import React from 'react';
import { motion } from 'framer-motion';
import {
    dynamicsModules,
    liveProjectsLearnersD365,
    liveProjectsBusinessesD365,
    businessBenefitsD365,
    recentProjectsD365,
    trainingOfferingsD365,
    trainingModulesD365,
    whyChooseUsD365
} from '../../data/expertiseData'; // Import Dynamics 365 data

// Placeholder Icons - Use actual icons later
const DynamicsIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"></path>
    </svg>
);
const CheckCircleIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="14" width="14" xmlns="http://www.w3.org/2000/svg"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
);
const BriefcaseIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"></path></svg>
);
const UserGroupIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"></path></svg>
);
const CheckIconBig = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
);
const CheckIconGreen = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="18" width="18" xmlns="http://www.w3.org/2000/svg"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
);
const OfficeBuildingIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"></path></svg>
);

function DynamicsExpertise() {

    const sectionVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    const gridContainerVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { staggerChildren: 0.1 } }
    };

    const gridItemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
    };

  return (
    <section id="dynamics-services" className="py-20 bg-white overflow-hidden border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
            className="text-center mb-16"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={sectionVariants}
        >
          <span className="text-[#0078D4] font-semibold tracking-wider uppercase">Our Dynamics 365 Expertise</span>
          <h2 className="text-4xl font-bold text-gray-900 mt-2 mb-4">Comprehensive Dynamics 365 Solutions</h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            Unlocking business potential with Microsoft Dynamics 365 suite for CRM and ERP needs.
          </p>
        </motion.div>

        <motion.div
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20"
            variants={gridContainerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
        >
          {dynamicsModules.map((module, index) => (
            <motion.div
                key={index}
                className="bg-gray-50 rounded-xl shadow-lg hover:shadow-[#0078d4]/20 transition-shadow p-6 h-full"
                variants={gridItemVariants}
             >
              <div className="flex items-center mb-4">
                <div className="mr-3 bg-blue-100 p-3 rounded-lg text-[#0078D4]">
                  <DynamicsIcon />
                </div>
                <h3 className="text-xl font-bold text-gray-800">{module.title}</h3>
              </div>
              <ul className="space-y-2 mt-4">
                {module.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start">
                    <span className="text-[#0078D4] mt-1 mr-2 flex-shrink-0"><CheckCircleIcon /></span>
                    <span className="text-gray-700 text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
            className="mb-16"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={sectionVariants}
            transition={{ delay: 0.2 }}
            >
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Live Dynamics 365 Projects for Training & Business Solutions</h2>
            <p className="text-gray-700 max-w-4xl mx-auto">
              Implement powerful Microsoft business applications or gain hands-on D365 skills through our project-based approach.
            </p>
          </div>

          <motion.div
            className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12"
            variants={gridContainerVariants}
           >
            <motion.div className="bg-gray-50 rounded-xl overflow-hidden shadow-lg" variants={gridItemVariants}>
              <div className="bg-gradient-to-r from-[#0078D4] to-blue-700 px-6 py-4 flex items-center">
                <div className="bg-white/20 p-3 rounded-lg text-white mr-4"><UserGroupIcon /></div>
                <h3 className="text-xl font-bold text-white">For D365 Learners: Hands-on Live Projects</h3>
              </div>
              <div className="p-6">
                <p className="text-gray-700 mb-4 text-sm">
                    Our Dynamics 365 projects provide learners with practical experience in configuring, customizing, and integrating D365 applications to solve real business problems.
                </p>
                <div className="mb-4">
                  <h4 className="text-md font-semibold mb-2 text-gray-800">🔹 Who Can Join?</h4>
                  <p className="text-gray-700 text-sm">
                    Aspiring D365 Functional Consultants, Technical Consultants, Power Platform Developers, and IT professionals moving into business applications.
                  </p>
                </div>
                <h4 className="text-md font-semibold mb-2 text-gray-800">Examples of Live Projects:</h4>
                <ul className="space-y-2 mb-6">
                  {liveProjectsLearnersD365.map((project, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="text-green-500 mt-1 mr-2 flex-shrink-0"><CheckIconBig /></span>
                      <span className="text-gray-700 text-sm">{project}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>

            <motion.div className="bg-gray-50 rounded-xl overflow-hidden shadow-lg" variants={gridItemVariants}>
              <div className="bg-gradient-to-r from-[#0078D4] to-blue-700 px-6 py-4 flex items-center">
                <div className="bg-white/20 p-3 rounded-lg text-white mr-4"><BriefcaseIcon /></div>
                <h3 className="text-xl font-bold text-white">For Businesses: Real-Time D365 Implementation</h3>
              </div>
               <div className="p-6">
                 <p className="text-gray-700 mb-4 text-sm">
                     We partner with businesses to implement and optimize Dynamics 365 solutions, ensuring seamless integration and alignment with strategic objectives.
                 </p>
                 <h4 className="text-md font-semibold mb-2 text-gray-800">Examples of Live Projects:</h4>
                  <ul className="space-y-2 mb-6">
                   {liveProjectsBusinessesD365.map((project, idx) => (
                     <li key={idx} className="flex items-start">
                       <span className="text-green-500 mt-1 mr-2 flex-shrink-0"><CheckIconBig /></span>
                       <span className="text-gray-700 text-sm">{project}</span>
                     </li>
                   ))}
                 </ul>
                 <div>
                   <h4 className="text-md font-semibold mb-2 text-gray-800">📌 How It Benefits Businesses?</h4>
                    <ul className="space-y-2">
                       {businessBenefitsD365.map((benefit, idx) => (
                         <li key={idx} className="flex items-start">
                           <span className="text-green-500 mt-1 mr-2 flex-shrink-0"><CheckIconBig /></span>
                           <span className="text-gray-700 text-sm">{benefit}</span>
                         </li>
                       ))}
                     </ul>
                 </div>
               </div>
            </motion.div>
          </motion.div>

            <motion.div
                className="bg-gray-50 rounded-xl p-6 shadow-lg mt-6"
                variants={gridItemVariants}
             >
                <h3 className="text-xl font-bold text-gray-800 mb-4">Recent Live Dynamics 365 Projects:</h3>
                {recentProjectsD365.map((project, idx) => (
                    <div key={idx} className="flex items-start mb-4 last:mb-0">
                        <span className="text-green-500 mt-1 mr-3 flex-shrink-0"><CheckIconGreen /></span>
                        <div>
                            <h4 className="font-semibold text-gray-800">{project.title}</h4>
                            <p className="text-gray-600 text-sm">{project.description}</p>
                        </div>
                    </div>
                ))}
            </motion.div>
        </motion.div>

         <motion.div
            className="mb-16"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={sectionVariants}
            transition={{ delay: 0.3 }}
        >
            <div className="bg-gray-50 rounded-xl overflow-hidden shadow-xl">
                <div className="bg-gradient-to-r from-[#0078D4] to-blue-700 px-6 py-4">
                    <div className="flex items-center">
                        <div className="bg-white/20 p-3 rounded-lg text-white mr-4"><UserGroupIcon /></div>
                        <h3 className="text-2xl font-bold text-white">Dynamics 365 Training Programs</h3>
                    </div>
                </div>
                <div className="p-8">
                    <p className="text-gray-700 mb-6 text-sm">Develop expertise in Dynamics 365 with our role-based training programs designed for real-world application and certification success.</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                        <div>
                            <h4 className="text-lg font-semibold mb-3 text-gray-800">Training Offerings:</h4>
                            <ul className="space-y-2">
                                {trainingOfferingsD365.map((offering, idx) => (
                                    <li key={idx} className="flex items-start">
                                        <span className="text-[#0078D4] mt-1 mr-2 flex-shrink-0"><CheckIconBig /></span>
                                        <span className="text-gray-700 text-sm">{offering}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <h4 className="text-lg font-semibold mb-3 text-gray-800">Training Modules We Offer:</h4>
                            <ul className="space-y-2">
                                {trainingModulesD365.map((mod, idx) => (
                                    <li key={idx} className="flex items-start">
                                        <span className="text-[#0078D4] mt-1 mr-2 flex-shrink-0"><CheckIconBig /></span>
                                        <span className="text-gray-700 text-sm">{mod}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <p className="text-gray-700 italic text-sm">Gain the skills needed to implement, customize, and manage Dynamics 365 solutions effectively.</p>
                </div>
            </div>
        </motion.div>

        <motion.div
            className="bg-gray-50 rounded-xl p-8 shadow-lg"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={sectionVariants}
            transition={{ delay: 0.1 }}
        >
          <div className="flex items-center mb-6">
            <div className="bg-blue-100 p-3 rounded-lg text-[#0078D4] mr-4"><OfficeBuildingIcon /></div>
            <h3 className="text-2xl font-bold text-gray-800">Why Choose Us for Dynamics 365?</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {whyChooseUsD365.map((reason, idx) => (
                <div key={idx} className="flex items-start">
                    <span className="text-green-500 mt-1 mr-3 flex-shrink-0"><CheckIconGreen /></span>
                    <span className="text-gray-700 text-sm">{reason}</span>
                </div>
            ))}
          </div>
          <p className="mt-6 text-gray-700 text-sm">We provide expert guidance and support to help you leverage the full potential of the Microsoft Dynamics 365 ecosystem.</p>
        </motion.div>

        <motion.div
            className="mt-16 text-center"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={sectionVariants}
            transition={{ delay: 0.2 }}
        >
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Streamline Your Business with Dynamics 365?</h3>
          <p className="text-lg text-gray-700 mb-8">Get in touch to explore how Dynamics 365 can optimize your operations.</p>
          <a href="#contact" className="bg-[#0078D4] text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-800 transition-colors inline-flex items-center">
            Discuss Dynamics 365
          </a>
        </motion.div>
      </div>
    </section>
  );
}

export default DynamicsExpertise; 